export default __webpack_public_path__ + "b79915d0fae04288ce3877683ba01ade.png";